import moment from 'moment';
import { Box, Button, Container, Text } from 'octiv-components';
import { useActiveUserTenant } from 'octiv-context/ActiveUserTenant';
import { usePaging } from 'octiv-hooks';
import {
  useReportsFindFinanceVat,
  useReportsFindFinanceVatExport,
} from 'octiv-hooks/requests/Reports';
import { downloadFile, getDateYearMonthDay } from 'octiv-utilities/Functions';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormQuery from './FormQuery';
import TableReport from './TableReport';

export default () => {
  const { t } = useTranslation();

  const {
    selectedLocation,
    tenant: { locations },
    toCurrency,
  } = useActiveUserTenant();
  const [vatTotal, setVatTotal] = useState(undefined);
  const [paging, setPaging, resetPaging] = usePaging();
  const vatLocations = locations.filter(
    (location) =>
      location.vat !== undefined && location.vat !== null && location.vat !== ''
  );
  const [query, setQuery] = useState({
    locationId:
      vatLocations.find((item) => item.id === selectedLocation?.id)?.id ||
      vatLocations[0]?.id,
    status: undefined,
    startDate: getDateYearMonthDay({ date: moment().subtract(1, 'month') }),
    endDate: getDateYearMonthDay({ canFallback: true }),
    search: '',
    sort: '-due_on',
    type: undefined,
  });

  const { data: report, isFetching: isFetchingReport } =
    useReportsFindFinanceVat(
      { filter: query, sort: query.sort, paging },
      {
        onSuccess: (response) => {
          if (response && response?.data && response?.data?.[0]) {
            setVatTotal(
              response.data.reduce((a, b) => a + Number(b.vatAmount), 0)
            );
          } else {
            setVatTotal(undefined);
          }
        },
      }
    );

  const findVatExport = useReportsFindFinanceVatExport(
    { filter: query, sort: query.sort, paging },
    {
      enabled: false,
      onSuccess: downloadFile,
    }
  );

  useEffect(() => {
    if (query.type === 'csv' || query.type === 'pdf') {
      findVatExport.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.type]);

  return (
    <Container
      appBarProps={{
        title: t('vat'),
        breadcrumbs: [t('reports'), t('finance')],
        children: (
          <Box ml='auto'>
            <Box isFlex>
              <Button
                hasBorder
                mr={2}
                text={t('csvExport')}
                onClick={() => {
                  setQuery((prev) => ({
                    ...prev,
                    type: 'csv',
                  }));
                }}
              />
            </Box>
          </Box>
        ),
      }}
      isLoading={isFetchingReport}
    >
      <FormQuery
        initialValues={query}
        vatLocations={vatLocations}
        onResetPaging={resetPaging}
        onSubmit={(values) =>
          setQuery((prev) => ({
            ...values,
            sort: prev.sort,
          }))
        }
      />

      <Box height={4} />

      <TableReport
        data={report?.data || []}
        isLoading={isFetchingReport}
        paging={report?.paging}
        setPaging={setPaging}
        onSortBy={(values) => setQuery((prev) => ({ ...prev, ...values }))}
      />

      {vatTotal && !isFetchingReport && (
        <Text textAlign='right' variant='heading'>
          {`${t('vatTotal')}: ${toCurrency({
            value: vatTotal,
          })}`}
        </Text>
      )}
    </Container>
  );
};
